"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useProductsCount = void 0;

var _reactRedux = require("react-redux");

var _react = require("react");

var _productsCount = require("../store/productsCount/productsCount.selectors");

var _productsCount2 = require("../store/productsCount/productsCount.actions");

var useProductsCount = function useProductsCount(_ref) {
  var filters = _ref.filters,
      _ref$fetch = _ref.fetch,
      fetch = _ref$fetch === void 0 ? true : _ref$fetch;
  var dispatch = (0, _reactRedux.useDispatch)();
  var count = (0, _reactRedux.useSelector)((0, _react.useMemo)(function () {
    return (0, _productsCount.makeGetProductsCountByFilters)(filters);
  }, [filters]));
  var isPending = count === null;
  var isFulfilled = typeof count === 'number';
  var isNeedFetch = fetch && typeof count === 'undefined';
  (0, _react.useEffect)(function () {
    if (isNeedFetch) {
      dispatch((0, _productsCount2.fetchProductsCount)(filters));
    }
  }, [dispatch, filters, isNeedFetch]);
  return (0, _react.useMemo)(function () {
    return {
      count: count !== null && count !== void 0 ? count : 0,
      isPending,
      isFulfilled
    };
  }, [count, isFulfilled, isPending]);
};

exports.useProductsCount = useProductsCount;